import { angleDistance } from '../are_angles_within.js'
import { gsap } from 'gsap'

const nearestKeyIndexToAngle = (positions, angle) => {
	let nearest_key_index = 0
	let min = 1000

	// TODO. We dont need to continue looping after certain condition.
	positions.forEach(({ rotation, index }) =>{
		const distance = angleDistance(rotation, angle)

		if(distance < min){
			min = distance
			nearest_key_index = index
		}
	})

	return nearest_key_index
}

const circularIndex = (index, max) => {
  return index <= max ? index : ((index - 1) % max) + 1;
}

const matrixAnimationEffect = (keys_matrix, keys_container, start_delay)=>{
	const col_count = keys_matrix[0]?.length

	if(!col_count){
		return
	}

	const timeouts = []

	const addTimeout = (fn, delay) => timeouts.push(setTimeout(fn, delay))

	const intervals = []

	const addInterval = (fn, delay) => intervals.push(setInterval(fn, delay))

	const timelines = []

	const runEffectChain = row_index =>{
		keys_matrix[row_index].map((key, key_index) =>{
			if(!key){
				return
			}

			const key_flat_index = col_count*row_index + key_index

			const key_ref = keys_container.querySelector(`.key-${key_flat_index}`)

			const timeline = gsap.timeline()

			timelines.push(timeline)

			const target = key_ref
			const to = vars => timeline.to(target, vars);

			addTimeout(
				()=>{
					timeline.set(target, {
						opacity: Math.random()*0.6 + 0.2,
						backgroundColor: '#eaeaea',
						borderRadius: '3px',
						filter: 'drop-shadow(1px 1px 4px rgba(255, 255, 255, 1))',
						backdropFilter: "opacity(0.2)"
					})
					
					to({
						opacity: Math.random()*0.2 + 0.2,
						duration: 0.3,
						ease: "sine",
					})

					to({
						opacity: 0,
						duration: 0.8,
						ease: "sine",
						filter: "blur(1px)"
					})
				},
				Math.random()*10 + 100*(key_index + 1)
			)
		})
	}

	const sequences = [
		
		[[5,0,6,1], 	Math.random() * 70 + 830],
		[[4,1,5,2], 	Math.random() * 70 + 900],
		[[3,2,4,3], 	Math.random() * 100 + 1020],
		[[2,3,3,4], 	Math.random() * 100 + 1080],
		[[0,1,6,5], 	Math.random() * 50 + 2050],
		[[6,5,0,1], 	Math.random() * 50 + 2080],
		[[1,4,2,5], Math.random() * 70 +	4050],
	]

	const runEffectChainSequence = (sequence)=> {
		runEffectChain(sequence[0])

		sequence.push(sequence.shift())
	}

	addTimeout(()=>{
		sequences.forEach(([sequence, delay]) =>
			addInterval(()=> runEffectChainSequence(sequence), delay)
		)
	}, start_delay)

	return ()=> {
		intervals.forEach(clearInterval)
		timeouts.forEach(clearTimeout)
		timelines.forEach(timeline => timeline.kill())
	}
}

export default matrixAnimationEffect